import React from "react";
import Grid from "@mui/material/Grid";
import QMSCard from "./QMSCard";

const QMSApp = () => {
  const cardData = [
    {
      title: "INMETRO",
      subheader: "01/03/1998",
      logo: "/img/inmetro.png",
      status: "100%",
      description: "Sistema de gestão INMETRO",
      lastInternalAudit: "October 14, 2024",
      nextInternalAudit: "October 14, 2025",
      lastExternalAudit: "November 14, 2024",
      nextExternalAudit: "November 14, 2025",
      actions: [
        { label: "Acessar", onClick: () => console.log("Acessar") },
        // { label: 'Edit', onClick: () => console.log('Edit Task 1') },
      ],
    },
    {
      title: "ISO17025",
      subheader: "20/03/1998",
      logo: "/img/iso17025.png",
      description: "Sistema de gestão ISO17025",
      lastInternalAudit: "October 14, 2024",
      nextInternalAudit: "October 14, 2025",
      lastExternalAudit: "November 14, 2024",
      nextExternalAudit: "November 14, 2025",
      status: "100%",
      actions: [
        { label: "Acessar", path: "/qms/iso17025" },
        // { label: 'Edit', onClick: () => console.log('Edit Task 2') },
      ],
    },
    {
      title: "ISO9001",
      subheader: "01/03/1998",
      logo: "/img/iso9001.png",
      description: "Sistema de gestão ISO9001",
      lastInternalAudit: "14/10/2024",
      nextInternalAudit: "14/10/2025",
      lastExternalAudit: "14/11/2024",
      nextExternalAudit: "14/11/2025",
      status: "100%",
      actions: [
        { label: "Acessar", onClick: () => console.log("Acessar") },
        // { label: 'Edit', onClick: () => console.log('Edit Task 2') },
      ],
    },
  ];

  return (
    <Grid container spacing={2} sx={{ maxWidth: { xs: 320, sm: "100%" } }}>
      {cardData.map((card, index) => (
        <Grid item key={index} xs={12} sm={6} md={4}>
          <QMSCard
            title={card.title}
            subheader={card.subheader}
            logo={card.logo}
            status={card.status}
            description={card.description}
            actions={card.actions}
            lastInternalAudit={card.lastInternalAudit}
            nextInternalAudit={card.nextInternalAudit}
            lastExternalAudit={card.lastExternalAudit}
            nextExternalAudit={card.nextExternalAudit}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default QMSApp;
